import React from 'react'

const Logo = ({
  isPlaying = false
}) => {
  return (
    <div
      className={`
        absolute top-0 left-0 right-0 z-10 text-center
        ${!isPlaying ? 'opacity-100' : ''}
        ${isPlaying? 'opacity-0 transition-opacity duration-1000 ease-out' : ''}
      `}>
      <img src='/media/fussy/fussy-logo.png'
        alt='Fussy Logo'
        className='w-8 mx-auto ' />
    </div>
  )
}

export default Logo